import {
  ReimbursablePayrollConceptFragment,
  TimeSettingsCustomTimeRangeCategoryFragment,
} from 'generated/resources/graphql'

import { timeRangeCategoryTypeEnum } from 'modules/attendance/lib/enums'

/**
 * Returns the subset of time range categories that have no valid payroll concept mapping.
 *
 * Only reimbursements with type TimeSettings::CustomTimeRangeCategory are considered valid.
 * This ensures that mappings for other types (e.g. Finance::CustomCategory) don't
 * incorrectly satisfy the check.
 *
 * The caller is responsible for passing only active categories — archived categories
 * should be excluded before calling this function (BR-COMP-022).
 */
export const getTimeCategoriesWithoutMappings = (
  categories: TimeSettingsCustomTimeRangeCategoryFragment[],
  reimbursements: ReimbursablePayrollConceptFragment[]
): TimeSettingsCustomTimeRangeCategoryFragment[] => {
  const reimbursementByCategoryId = new Map<string, ReimbursablePayrollConceptFragment>()

  for (const reimbursement of reimbursements) {
    if (
      reimbursement.reimbursableType ===
      timeRangeCategoryTypeEnum.TimeSettingsCustomTimeRangeCategory
    ) {
      reimbursementByCategoryId.set(reimbursement.reimbursableId, reimbursement)
    }
  }

  return categories.filter(
    (category) => !reimbursementByCategoryId.get(category.id)?.payrollConceptId
  )
}
